import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Context } from 'src/app/shared/models/context';
import { Epoch, Message, Quarter } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CompanyService } from 'src/app/shared/services/company.service';

@Component({
  selector: 'app-quarter-crud',
  templateUrl: './quarter-crud.component.html',
  styleUrls: ['./quarter-crud.component.scss']
})
export class QuarterCrudComponent implements OnInit {
  @Input() quarter: Quarter;
  @Input() context: Context;
  @Input() quarters: Quarter[] = [];
  public quarterTypes: string[] = [];
  public epochs: Epoch[] = [];
  public quarterForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public months: any[] = [];

  constructor(
    private companyService: CompanyService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.setQuarter(this.quarter);
    this.companyService.getEpochs(false).subscribe((epochs) => (this.epochs = epochs));
    this.months = this.commonService.getFullMonths();
  }
  public setQuarter(quarter?: Quarter) {
    if (!quarter)
      quarter = {
        id: null,
        label: null,
        fromMonth: null,
        toMonth: null,
        sequence: null,
        epochId: null,
        epochName: null,
        disabled: false,
      } as Quarter;
    this.quarterForm = this.fb.group({
      id: this.fb.control(quarter?.id || null),
      label: this.fb.control(quarter.label, [Validators.required, Validators.pattern(RegExp.label)]),
      fromMonth: this.fb.control(quarter.fromMonth, [Validators.required]),
      toMonth: this.fb.control(quarter.toMonth, [Validators.required]),
      epochId: this.fb.control(quarter.epochId, [Validators.required]),
      epochName: this.fb.control(quarter.epochName, []),
      sequence: this.fb.control(quarter.sequence, [Validators.required]),
      disabled: this.fb.control(quarter.disabled, []),
    });
    this.quarterForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.quarterForm.controls;
  }

  public saveQuarter(inProgress?: any) {
    this.submitted = true;
    if (this.quarterForm.valid) {
      const quarter: Quarter = this.quarterForm.value;
      if (this.quarters.some(h => h.label.toLowerCase() === quarter?.label?.toLowerCase())) {
        this.commonService.setToastr(400, `Quarter ${quarter.label} already exists!`);
        return;
      }
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Quarter ${quarter.label} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (quarter.id) {
        this.companyService.updateQuarter(quarter.id, quarter).subscribe({
          next: (response: Message) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Quarter ${quarter.label} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.companyService.createQuarter(quarter).subscribe({
          next: (response: Message) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Quarter ${quarter.label} has been created successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}
